module.exports = __webpack_public_path__ + "static/media/hero-bcg.7e99f26a.jpg";